module.exports = __webpack_public_path__ + "media/images/slides/babel2-cacd32b6ff4dc40f085821a5cd30fc71.jpg";